import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import moment from 'moment-timezone';
import Spinner from '../../spinner/spinner';
import { Form, Modal, Select } from 'antd';
import displayServerErrors from '../../../utilities/form/display_server_errors';
import { SuccessfullPage } from "./successfullPage";
import ChurchForm from "./form/churchForm";
import { createChurch } from "./mutations/createChurch";
import { getEvangelists } from "./queries/getEvangelists";
import { AVAILABLE_TIMEZONES } from "./constants";
import { ChurchGroupsFields } from "./form/churchGroupsFields";

const PASTORS_VALIDATION_FIELDS = ['email', 'name'];

class ChurchCreatePage extends Component {
  constructor(props) {
    super(props);
    this.state = { success: false, successData: null };
  }

  get mutationParams() {
    const {getFieldValue} = this.props.form;

    return {
      variables: {
        input: this.preprocessedFieldsValue
      }
    };
  }

  get preprocessedFieldsValue() {
    let values = {
      ...this.props.form.getFieldsValue(),
      evangelist_id: parseInt(this.props.form.getFieldValue('evangelist_id'), 10)
    }

    if (values["add_revival"]) {
      values.revival = this.revivalFields;
    } else {
      delete values["revival"]
    }

    delete values["add_revival"]

    return values;
  }

  get revivalFields() {
    const {getFieldValue} = this.props.form;

    if (!getFieldValue('add_revival')) return null

    const timezone = getFieldValue('timezone');

    return {
      title: getFieldValue('revival.title'),
      image_data_uri: getFieldValue('revival.image_data_uri'),
      preparation_start_date: moment(getFieldValue('revival.preparation_start_date')).utc().startOf('day').tz(timezone, true).unix(),
      start_date: moment(getFieldValue('revival.start_date')).utc().startOf('day').tz(timezone, true).unix(),
      end_date: moment(getFieldValue('revival.end_date')).utc().endOf('day').tz(timezone, true).unix()
    }
  }

  get saveConfirmationText() {
    return (
      <div>
        <p>Confirm saving new Church profile.</p>
        <p>Check that following data is set correctly:</p>
        <ul>
          <li>Church data</li>
          <li>Pastors emails</li>
        </ul>
      </div>
    );
  }

  get validationKeys() {
    return { senior_pastor: PASTORS_VALIDATION_FIELDS, pastors: PASTORS_VALIDATION_FIELDS };
  }

  get renderTimezoneField() {
    return (
      <Form.Item label="Timezone">
        {this.props.form.getFieldDecorator('timezone', {
          rules: [
            { required: true, message: 'Please select Timezone' }
          ],
        })(
          <Select showSearch filterOption={this.getTimezonesSelectFilterOptions} placeholder="Select timezone">
            {
              AVAILABLE_TIMEZONES.map((timezone, index) => {
                return (
                  <Select.Option key={index} value={timezone.value}>
                    {timezone.name}
                  </Select.Option>
                );
              })
            }
          </Select>
        )}
      </Form.Item>
    );
  }

  get renderEvangelistsField() {
    return (
      <Form.Item label="Evangelist">
        {this.props.form.getFieldDecorator('evangelist_id', {
          rules: [
            { required: true, message: 'Please select Evangelist' }
          ],
        })(
          <Select placeholder="Select evangelist">
            {
              this.props.data.evangelists && this.props.data.evangelists.filter((evangelist) => evangelist.passwordCreated).map((evangelist, index) => {
                return (
                  <Select.Option key={index} value={`${evangelist.id}`}>
                    {evangelist.name}
                  </Select.Option>
                );
              })
            }
          </Select>
        )}
      </Form.Item>
    );
  }

  get renderGroupsField() {
    return <ChurchGroupsFields form={this.props.form}/>;
  }

  async submitData() {
    try {
      this.setState({loading: true});
      const {data} = await this.props.mutate(this.mutationParams);
      return data.createChurch.church;
    } catch(response) {
      displayServerErrors(this.props.form, response, this.validationKeys);
    } finally {
      this.setState({ loading: false });
    }
  }

  getTimezonesSelectFilterOptions(input, option) {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  onSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((error) => {
      if (!error) {
        Modal.confirm({
          title: this.saveConfirmationText,
          cancelText: "Back to checking church data",
          okText: "Save profile now",
          width: 600,
          onOk: () => this.submitData().then((data) => {
            if (data) {
              this.setState({success: true, successData: data});
            }
          })
        });
      }
    });
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    } else {
      if (this.state.success) {
        return <SuccessfullPage successData={this.state.successData} />
      } else {
        return (
          <div>
            <ChurchForm {...this.props} form={this.props.form}
                        evangelistsField={this.renderEvangelistsField}
                        timezoneField={this.renderTimezoneField}
                        groupsField={this.renderGroupsField}
                        onSubmit={this.onSubmit}/>
          </div>
        );
      }
    }
  }
}

export default Form.create()(compose(
  graphql(createChurch),
  graphql(getEvangelists)
)(ChurchCreatePage));



// WEBPACK FOOTER //
// ./src/components/pages/churches/churchCreate.js